(() => {
  const STORAGE_KEY = 'bnb:last-shopping-page';

  function isShoppingPage(url) {
    return (
      url.origin === window.location.origin &&
      (
        url.pathname.includes('/products/') ||
        url.pathname.includes('/collections/')
      )
    );
  }

  function saveCurrentPage() {
    try {
      const currentUrl = new URL(window.location.href);

      if (isShoppingPage(currentUrl)) {
        sessionStorage.setItem(
          STORAGE_KEY,
          currentUrl.pathname + currentUrl.search
        );
      }
    } catch (error) {
      console.warn('Unable to save shopping page', error);
    }
  }

  function getLastShoppingPage(fallback) {
    const stored = sessionStorage.getItem(STORAGE_KEY);

    if (stored) {
      try {
        const url = new URL(stored, window.location.origin);

        if (isShoppingPage(url)) {
          return url.pathname + url.search;
        }
      } catch (error) {
        console.warn('Invalid stored shopping URL', error);
      }
    }

    return fallback;
  }

  function updateContinueShoppingLinks() {
    document
      .querySelectorAll('[data-continue-shopping]')
      .forEach(link => {
        const fallback =
          link.dataset.fallbackUrl ||
          link.getAttribute('href') ||
          '/collections/all';

        link.href = getLastShoppingPage(fallback);
      });
  }

  saveCurrentPage();

  document.addEventListener('DOMContentLoaded', () => {
    updateContinueShoppingLinks();
  });

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-continue-shopping]');

    if (link) {
      const fallback =
        link.dataset.fallbackUrl ||
        '/collections/all';

      link.href = getLastShoppingPage(fallback);
    }
  });
})();